export default __webpack_public_path__ + "static/media/Sverigetaxi.58db6e43.jpg";